"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onErrorRetry = exports.ArgumentsError = exports.NotFoundError = void 0;
class NotFoundError extends Error {
}
exports.NotFoundError = NotFoundError;
class ArgumentsError extends Error {
}
exports.ArgumentsError = ArgumentsError;
const onErrorRetry = (err, _, __, revalidate, revalidateOpts) => {
    if (err instanceof NotFoundError) {
        // Don't retry for 404 records
        return;
    }
    if (err instanceof ArgumentsError) {
        // Don't retry for invalid arguments
        return;
    }
    if (revalidateOpts.retryCount || 5 < 4) {
        // Retry with error other than not found
        revalidate(revalidateOpts);
    }
};
exports.onErrorRetry = onErrorRetry;
